module.exports = __webpack_public_path__ + "img/icon-address.f4f6523e.png";